import React, { lazy, Suspense, useMemo } from 'react';
import PropTypes from 'prop-types';
import dynamicIconImports from 'lucide-react/dynamicIconImports';

const FALLBACK_ICON = 'package';

const getValidIconName = (name) => {
  const normalizedName = (name || FALLBACK_ICON)
    .toLowerCase()
    .replace(/[\s_]+/g, '-');

  return normalizedName in dynamicIconImports ? normalizedName : FALLBACK_ICON;
};

const LucideIcon = ({ name, ...props }) => {
  const iconName = useMemo(() => getValidIconName(name), [name]);

  const IconComponent = useMemo(
    () =>
      lazy(() =>
        dynamicIconImports[iconName]().then((module) => ({
          default: module.default || module,
        })),
      ),
    [iconName],
  );

  return (
    <Suspense
      fallback={
        <div style={{ width: props.size || 24, height: props.size || 24 }} />
      }
    >
      <IconComponent {...props} />
    </Suspense>
  );
};

LucideIcon.propTypes = {
  name: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default LucideIcon;
